import React, { useEffect, useState } from 'react';
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import AccountManagerApi from '../../Api/AccountManager';
import Swal from 'sweetalert2';

const AccountManagerMaster = () => {
    const [data, setData] = useState([]);
    const [itemId, setItemId] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [inputs, setInputs] = useState({
        Username: '',
        name: '',
        contact: '',
        password: '',
        confirmPassword: '',
        itemDepartment: '',
        fixAgentBooked: '',
        loginType: 'user',
        max_discount: '',
        reservedField1: '',
        reservedField2: '',
        reservedField3: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prev) => ({ ...prev, [name]: value }));
    };

    const togglePasswordVisibility = (field) => {
        if (field === 'password') setShowPassword((prev) => !prev);
        if (field === 'confirmPassword') setShowConfirmPassword((prev) => !prev);
    };

    const handleSave = async () => {
        if (!inputs.name) {
            Swal.fire({ title: 'Validation', text: 'Name is required', icon: 'warning', width: '320px' });
            return;
        }

        if ((inputs.password || inputs.confirmPassword) && inputs.password !== inputs.confirmPassword) {
            Swal.fire({ title: 'Validation', text: 'Password and Confirm Password must match', icon: 'warning', width: '320px' });
            return;
        }
        if (!inputs.reservedField1) {
            Swal.fire({ title: 'Validation', text: 'Email is required', icon: 'warning', width: '320px' });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(inputs.reservedField1)) {
            Swal.fire({ title: 'Validation', text: 'Enter a valid email address', icon: 'warning', width: '320px' });
            return;
        }

        const payload = {
            Username: inputs.Username,
            name: inputs.name,
            contact: inputs.contact,
            password: inputs.password || undefined,
            itemDepartment: inputs.itemDepartment,
            fixAgentBooked: inputs.fixAgentBooked,
            loginType: inputs.loginType,
            max_discount: inputs.max_discount || undefined,
            reservedField1: inputs.reservedField1 || undefined,
            reservedField2: inputs.reservedField2 || undefined,
            reservedField3: inputs.reservedField3 || undefined,
        };

        const response = await AccountManagerApi.CreateAccountManager(payload);
        if (response?.StatusCode === 409) {
            Swal.fire({ title: 'Exists', text: response.ErrorMessages || 'User already exist.', icon: 'warning', width: '320px' });
            return;
        }
        if (response?.StatusCode === 500) {
            Swal.fire({ title: 'Error', text: response.ErrorMessages || 'Server error', icon: 'error', width: '320px' });
            return;
        }
        if (response) {
            const extra = response.Result?.generatedPassword ? ` Generated password: ${response.Result.generatedPassword}` : '';
            Swal.fire({ title: 'Created', text: `Created Successfully.${extra}`, icon: 'success', width: '320px' });
            setItemId('');
            setInputs({
                Username: '',
                name: '',
                contact: '',
                password: '',
                confirmPassword: '',
                itemDepartment: '',
                fixAgentBooked: '',
                loginType: 'user',
                max_discount: '',
                reservedField1: '',
                reservedField2: '',
                reservedField3: '',
            });
            fetchData();
        } else {
            Swal.fire({ title: 'Error', text: 'Create failed', icon: 'error', width: '320px' });
        }
    };

    const handleUpdate = async () => {
        if (!itemId) return;
        if ((inputs.password || inputs.confirmPassword) && inputs.password !== inputs.confirmPassword) {
            Swal.fire({ title: 'Validation', text: 'Password and Confirm Password must match', icon: 'warning', width: '320px' });
            return;
        }
        if (!inputs.reservedField1) {
            Swal.fire({ title: 'Validation', text: 'Email is required', icon: 'warning', width: '320px' });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(inputs.reservedField1)) {
            Swal.fire({ title: 'Validation', text: 'Enter a valid email address', icon: 'warning', width: '320px' });
            return;
        }
        const payload = {
            currentPassword: inputs.password || undefined,
            newPassword: inputs.confirmPassword || undefined,
            Username: inputs.Username,
            name: inputs.name,
            contact: inputs.contact,
            itemDepartment: inputs.itemDepartment,
            fixAgentBooked: inputs.fixAgentBooked,
            loginType: inputs.loginType,
            max_discount: inputs.max_discount || undefined,
            reservedField1: inputs.reservedField1 || undefined,
            reservedField2: inputs.reservedField2 || undefined,
            reservedField3: inputs.reservedField3 || undefined,
        };
        const response = await AccountManagerApi.UpdateById(itemId, payload);
        if (response?.StatusCode === 409) {
            Swal.fire({ title: 'Exists', text: response.ErrorMessages || 'User already exist.', icon: 'warning', width: '320px' });
            return;
        }
        if (response?.StatusCode === 500) {
            Swal.fire({ title: 'Error', text: response.ErrorMessages || 'Server error', icon: 'error', width: '320px' });
            return;
        }
        if (response) {
            Swal.fire({ title: 'Updated', text: 'Updated Successfully', icon: 'success', width: '320px' });
            setItemId('');
            setInputs({
                Username: '',
                name: '',
                contact: '',
                password: '',
                confirmPassword: '',
                itemDepartment: '',
                fixAgentBooked: '',
                loginType: 'user',
                max_discount: '',
                reservedField1: '',
                reservedField2: '',
                reservedField3: '',
            });
            fetchData();
        }
    };

    const fetchData = async () => {
        const response = await AccountManagerApi.GetAllAccountManager();
        if (response) {
            setData(response.Result || []);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleEdit = (item) => {
        setItemId(item.id);
        setInputs({
            Username: item.Username || '',
            name: item.name || '',
            contact: item.contact || '',
            password: '',
            confirmPassword: '',
            itemDepartment: item.itemDepartment || '',
            fixAgentBooked: item.fixAgentBooked || '',
            loginType: item.loginType || 'user',
            max_discount: item.max_discount || '',
            reservedField1: item.reservedField1 || '',
            reservedField2: item.reservedField2 || '',
            reservedField3: item.reservedField3 || '',
        });
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this Account Manager?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await AccountManagerApi.DeleteById(id);
        if (response.StatusCode === 200) {
            Swal.fire({ title: "Deleted", text: "Deleted Successfully", icon: "success", width: "320px" });
            fetchData();
        }
        setData((prev) => prev.filter((item) => item.id !== id));
    };


    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Account Manager</h2>
                </div>

                <div className='control_radius'>
                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='name' value={inputs.name} onChange={handleChange} required />
                                    <label className='modify_p_text2'>Name</label>
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='Username' value={inputs.Username} onChange={handleChange} />
                                    <label className='modify_p_text2'>Username (optional)</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='contact' value={inputs.contact} onChange={handleChange} />
                                    <label className='modify_p_text2'>Contact</label>
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input
                                        className='modify_im_input mode_category1'
                                        type={showPassword ? 'text' : 'password'}
                                        name='password'
                                        value={inputs.password}
                                        onChange={handleChange}
                                    />
                                    <label className='modify_p_text2'>{itemId ? 'Current Password (optional)' : 'Password (optional)'}</label>
                                </div>
                                <div className='input-image' onClick={() => togglePasswordVisibility('password')}>
                                    {showPassword ? <Icon icon="streamline:visible-solid" className='visible-icon' /> : <Icon icon="ant-design:eye-invisible-filled" className='visible-icon' />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input
                                        className='modify_im_input mode_category1'
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        name='confirmPassword'
                                        value={inputs.confirmPassword}
                                        onChange={handleChange}
                                    />
                                    <label className='modify_p_text2'>Confirm Password</label>
                                </div>
                                <div className='input-image' onClick={() => togglePasswordVisibility('confirmPassword')}>
                                    {showConfirmPassword ? <Icon icon="streamline:visible-solid" className='visible-icon' /> : <Icon icon="ant-design:eye-invisible-filled" className='visible-icon' />}
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2 user_add'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='itemDepartment' value={inputs.itemDepartment} onChange={handleChange} />
                                    <label className='modify_p_text2'>Item Department</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2 user_add'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='fixAgentBooked' value={inputs.fixAgentBooked} onChange={handleChange} />
                                    <label className='UseMasterLebalFix'>Fix Agent/Booked</label>
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2 user_add'>
                                <div className='input-box-mok1'>
                                    <select className='modify_im_input mode_category1' name='loginType' value={inputs.loginType} onChange={handleChange}>
                                        <option className='s-1 form-control' value='0'>Select</option>
                                        <option className='s-1 form-control' value='admin'>Admin</option>
                                        <option className='s-1 form-control' value='user'>User</option>
                                        <option className='s-1 form-control' value='sales'>Sales</option>
                                        <option className='s-1 form-control' value='support'>Support</option>
                                        <option className='s-1 form-control' value='development'>Development</option>
                                        <option className='s-1 form-control' value='accountmanager'>Account Manager</option>
                                    </select>
                                    <label className='UseMasterLebalFix '>Login Type</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='number' name='max_discount' value={inputs.max_discount} onChange={handleChange} />
                                    <label className='modify_p_text2'>Max Discount</label>
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='reservedField1' value={inputs.reservedField1} onChange={handleChange} />
                                    <label className='modify_p_text2'>Email</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='company_control'>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='reservedField2' value={inputs.reservedField2} onChange={handleChange} />
                                    <label className='modify_p_text2'>Reserved Field 1</label>
                                </div>
                            </div>
                        </div>
                        <div className='stock-im-dep1'>
                            <div className='input-box-Imo1 input-height2'>
                                <div className='input-box-mok1'>
                                    <input className='modify_im_input mode_category1' type='text' name='reservedField3' value={inputs.reservedField3} onChange={handleChange} />
                                    <label className='modify_p_text2'>Reserved Field 2</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='ButtonTabSave'>
                        {itemId ? (
                            <button id='SaveBtnMain' className='update-button-main-save hovered' onClick={handleUpdate}>
                                Update
                            </button>
                        ) : (
                            <button id='SaveBtnMain' className='save-button-main-save hovered' onClick={handleSave}>
                                Save
                            </button>
                        )}
                    </div>
                </div>

                <div className='company_info-text-im depart_top'>Account Manager List</div>
                <div className='control_radius'>
                    <div className='table-account-manager'>
                        <table className='table-master-acc'>
                            <thead className='header-table-account'>
                                <tr>
                                    <th className='table-header-manager'>S.No</th>
                                    <th className='table-header-manager'>Name</th>
                                    <th className='table-header-manager'>Username</th>
                                    <th className='table-header-manager'>Contact</th>
                                    <th className='table-header-manager'>Email Id</th>
                                    <th className='table-header-manager'>Item Department</th>
                                    <th className='table-header-manager'>Type</th>
                                    <th className='table-header-manager'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className='table-data-account'>{index + 1}</td>
                                        <td className='table-data-account'>{item.name}</td>
                                        <td className='table-data-account'>{item.Username}</td>
                                        <td className='table-data-account'>{item.contact}</td>
                                        <td className='table-data-account'>{item.reservedField1}</td>
                                        <td className='table-data-account'>{item.itemDepartment}</td>
                                        <td className='table-data-account'>{item.loginType}</td>
                                        <td>
                                            <button className='edit-btn-acc' onClick={() => handleEdit(item)}><Icon icon='lucide:edit' /></button>
                                            <button className='delete-btn-acc' onClick={() => handleDelete(item.id)}><Icon icon='material-symbols:delete' /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountManagerMaster;
